var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2857 0H7.71429C3.46011 0 0 3.55631 0 7.92857V29.0714C0 33.4438 3.4602 37 7.71429 37H28.2857C32.5399 37 36 33.4437 36 29.0714V7.92857C36 3.55623 32.5398 0 28.2857 0ZM33.4286 29.0714C33.4286 31.9868 31.1223 34.3571 28.2857 34.3571H7.71429C4.87769 34.3571 2.57143 31.9868 2.57143 29.0714V7.92857C2.57143 5.01318 4.87769 2.64286 7.71429 2.64286H28.2857C31.1223 2.64286 33.4286 5.01318 33.4286 7.92857V29.0714ZM18 7.92857C12.3285 7.92857 7.71429 12.6709 7.71429 18.5C7.71429 24.3291 12.3285 29.0714 18 29.0714C23.6715 29.0714 28.2857 24.3291 28.2857 18.5C28.2857 12.6709 23.6715 7.92857 18 7.92857ZM18 26.4286C13.7458 26.4286 10.2857 22.8723 10.2857 18.5C10.2857 14.1277 13.7459 10.5714 18 10.5714C22.2541 10.5714 25.7143 14.1277 25.7143 18.5C25.7143 22.8723 22.2541 26.4286 18 26.4286ZM29.1987 6.99025C29.4301 7.24132 29.5715 7.58487 29.5715 7.92849C29.5715 8.2721 29.4301 8.61563 29.1987 8.86672C28.9544 9.10458 28.6201 9.24994 28.2858 9.24994C27.9515 9.24994 27.6172 9.10458 27.3729 8.86672C27.1415 8.61565 27.0001 8.2721 27.0001 7.92849C27.0001 7.58487 27.1415 7.24134 27.3729 6.99025C27.8486 6.51454 28.7101 6.50134 29.1987 6.99025Z",
    fill: "#FFA5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bab7505257721ebd2d79750ab59d9e38.svg";
export { ForwardRef as ReactComponent };